import { AuthenticationGatekeeper } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/AuthenticationGatekeeper';
import LoadingScreen from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/LoadingScreen';
import MaybeLwtErrorBoundary from '@monorepo/shared/src/components/common/MaybeLwtErrorBoundary';
import AuthenticatedApp from './AuthenticatedApp';

const GatedApp: React.FC = () => {
  return (
    <AuthenticationGatekeeper
      Loading={<LoadingScreen />}
      options={{ getUserParams: ['settings', 'featureToggles'] }}
    >
      <MaybeLwtErrorBoundary>
        <AuthenticatedApp />
      </MaybeLwtErrorBoundary>
    </AuthenticationGatekeeper>
  );
};

export default GatedApp;
